import React, { Component } from 'react';
import definitions from './NotificationsDefinitions';
import GridPageView from '../shared/GridPageView';

export default class NotificationsPageView extends Component {
  render() {
    return (
      <GridPageView
        {...this.props}
        definitions={definitions}
        resourceName="notifications"
        resourceIdentifier="uuid"
        multipleName="Notificaties"
        singleName="Notificatie"
        hideCreate={true}
        onClick={(row) => {
          if (row.receiver_employee) {
            this.props.history.push('/employees/' + row.receiver_employee.uuid + '/');
          }
        }}
      />
    );
  }
}
